import { lazy, Suspense, memo } from 'react';
import { onButtonKey } from '../../../utils/common/a11y';

const iconImports = {
    // Основные иконки (часто используемые - можно оставить синхронными)
    car: () => import('./Car'),
    bike: () => import('./Bike'),
    commercial: () => import('./Commercial'),
    account: () => import('./Account'),
    search: () => import('./Search'),
    close: () => import('./Close'),
    check: () => import('./Check'),
    list: () => import('./List'),
    phone: () => import('./Phone'),
    mail: () => import('./Mail'),
    place: () => import('./Place'),

    // Остальные иконки - загружаются по требованию
    stop: () => import('./Stop'),
    copy: () => import('./Copy'),
    plusIcon: () => import('./PlusIcon'),
    cameraIcon: () => import('./CameraIcon'),
    disabledIcon: () => import('./DisabledIcon'),
    carGradient: () => import('./CarGradient'),
    bikeGradient: () => import('./BikeGradient'),
    youtube: () => import('./Youtube'),
    navi: () => import('./Navi'),
    premium: () => import('./Premium'),
    good: () => import('./Good'),
    lowPrice: () => import('./LowPrice'),
    highPrice: () => import('./HighPrice'),
    clear: () => import('./Clear'),
    edit: () => import('./Edit'),
    mastercard: () => import('./Mastercard'),
    visa: () => import('./Visa'),
    statistic: () => import('./Statistic'),
    sortingNumber: () => import('./SortingNumber'),
    eng: () => import('./Eng'),
    geo: () => import('./Georgia'),
    ua: () => import('./Ua'),
    rus: () => import('./Rus'),
    money: () => import('./Money'),
    taxi: () => import('./Taxi'),
    clock: () => import('./Clock'),
    police: () => import('./Police'),
    checkboxFilled: () => import('./CheckboxFilled'),
    checkboxEmpty: () => import('./CheckboxEmpty'),
    jeep: () => import('./Jeep'),
    carwashHood: () => import('./CarwashHood'),
    carwashRobot: () => import('./CarwashRobot'),
    carwashManual: () => import('./CarwashManual'),
    loader: () => import('./Loader'),
    tram: () => import('./Tram'),
    trailer: () => import('./Trailer'),
    sorting: () => import('./Sorting'),
    microbus: () => import('./Microbus'),
    bus: () => import('./Bus'),
    audio: () => import('./Audio'),
    chipTuning: () => import('./ChipTuning'),
    hotDrinks: () => import('./HotDrinks'),
    shop: () => import('./Shop'),
    wifi: () => import('./Wifi'),
    discount: () => import('./Discount'),
    electricService: () => import('./ElectricService'),
    restZone: () => import('./RestZone'),
    tools: () => import('./Tools'),
    pneumatic: () => import('./Pneumatic'),
    light: () => import('./Light'),
    electric: () => import('./Electric'),
    water: () => import('./Water'),
    compressor: () => import('./Compressor'),
    cafe: () => import('./Cafe'),
    dia: () => import('./Dia'),
    fastSell: () => import('./FastSell'),
    lock: () => import('./Lock'),
    carLoading: () => import('./CarLoading'),
    rightCircle: () => import('./RightCircle'),
    piston: () => import('./Piston'),
    carCrash: () => import('./CarCrash'),
    exit: () => import('./Exit'),
    painting: () => import('./Painting'),
    autoschool: () => import('./Autoschool'),
    towtruck: () => import('./Towtruck'),
    tyreservice: () => import('./Tyreservice'),
    insurance: () => import('./Insurance'),
    key: () => import('./Key'),
    garage: () => import('./Garage'),
    suspension: () => import('./Suspension'),
    gearbox: () => import('./Gearbox'),
    fan: () => import('./Fan'),
    repair: () => import('./Repair'),
    carDoor: () => import('./CarDoor'),
    gas: () => import('./Gas'),
    carMechanic: () => import('./CarMechanic'),
    motorsport: () => import('./Motorsport'),
    link: () => import('./Link'),
    dealer: () => import('./Dealer'),
    company: () => import('./Dealer'),
    abs: () => import('./Abs'),
    expert: () => import('./Expert'),
    placement: () => import('./Placement'),
    service: () => import('./Service'),
    danger: () => import('./Danger'),
    parts: () => import('./Parts'),
    verificate: () => import('./Verificate'),
    photoDelete: () => import('./DeleteBucket'),
    addButton: () => import('./Add'),
    starEmpty: () => import('./StarEmpty'),
    starFull: () => import('./StarFull'),
    info: () => import('./Info'),
    gear: () => import('./Gear'),
    fuel: () => import('./Fuel'),
    fuelElectro: () => import('./FuelElectro'),
    fuelDiesel: () => import('./FuelDiesel'),
    speedometr: () => import('./Speedometr'),
    documentCheck: () => import('./DocumentCheck'),
    documentNoCheck: () => import('./DocumentNoCheck'),
    auction: () => import('./Auction'),
    driveunit: () => import('./Driveunit'),
    engine: () => import('./Engine'),
    transmission: () => import('./Transmission'),
    credit: () => import('./Credit'),
    user: () => import('./User'),
    pro: () => import('./Pro'),
    bargain: () => import('./Bargain'),
    exchange: () => import('./Exchange'),
    airbag: () => import('./Airbag'),
    autoservice: () => import('./Autoservice'),
    carwash: () => import('./Carwash'),
    defects: () => import('./Defects'),
    disassembly: () => import('./Disassembly'),
    driveWheel: () => import('./DriveWheel'),
    photo: () => import('./Photo'),
    vin: () => import('./Vin'),
    date: () => import('./Date'),
    owners: () => import('./Owners'),
    climate: () => import('./Climate'),
    color: () => import('./Color'),
    seats: () => import('./Seats'),
    seatsInvalid: () => import('./SeatsInvalid'),
    seatsHeat: () => import('./SeatsHeat'),
    cruise: () => import('./Cruise'),
    video: () => import('./Video'),
    online: () => import('./Online'),
    plate: () => import('./Plate'),
    accBattery: () => import('./AccBattery'),
    carBoxGarage: () => import('./CarBoxGarage'),
    wheels: () => import('./Wheels'),
    oil: () => import('./Oil'),
    minus: () => import('./Minus'),
    location: () => import('./Location'),
    top: () => import('./Top'),
    checkmark: () => import('./Checkmark'),
    eyeHide: () => import('./EyeHide'),
    eyeShow: () => import('./EyeShow'),
    childSeat: () => import('./ChildSeat'),
    news: () => import('./News'),
    bump: () => import('./Bump').then((m) => ({ default: m.Bump })),
    highlight: () => import('./Highlight').then((m) => ({ default: m.Highlight })),
    whatsapp: () => import('./Whatsapp').then((m) => ({ default: m.Whatsapp })),
    viber: () => import('./Viber').then((m) => ({ default: m.Viber })),
    telegram: () => import('./Telegram').then((m) => ({ default: m.Telegram })),
    share: () => import('./Share').then((m) => ({ default: m.Share })),
    facebook: () => import('./Facebook').then((m) => ({ default: m.Facebook })),
    instagram: () => import('./Instagram').then((m) => ({ default: m.Instagram })),
    tiktok: () => import('./Tiktok').then((m) => ({ default: m.Tiktok })),
    copyLink: () => import('./CopyLink').then((m) => ({ default: m.CopyLink })),
    reset: () => import('./Reset').then((m) => ({ default: m.Reset })),

    // Бренды авто
    audi: () => import('./brands/Audi'),
    bmw: () => import('./brands/Bmw'),
    ford: () => import('./brands/Ford'),
    honda: () => import('./brands/Honda'),
    hyundai: () => import('./brands/Hyundai'),
    kia: () => import('./brands/Kia'),
    lexus: () => import('./brands/Lexus'),
    mazda: () => import('./brands/Mazda'),
    mercedesBenz: () => import('./brands/Mercedes'),
    nissan: () => import('./brands/Nissan'),
    toyota: () => import('./brands/Toyota'),
    volkswagen: () => import('./brands/Volkswagen'),

    // Бренды мото
    aprilia: () => import('./brands/Aprilia'),
    ducati: () => import('./brands/Ducati'),
    harleyDavidson: () => import('./brands/HarleyDavidson'),
    indian: () => import('./brands/Indian'),
    kawasaki: () => import('./brands/Kawasaki'),
    ktm: () => import('./brands/Ktm'),
    royalEnfield: () => import('./brands/RoyalEnfield'),
    suzuki: () => import('./brands/Suzuki'),
    triumph: () => import('./brands/Triumph'),
    yamaha: () => import('./brands/Yamaha'),

    // Бренды коммерческие
    daf: () => import('./brands/Daf'),
    isuzu: () => import('./brands/Isuzu'),
    iveco: () => import('./brands/Iveco'),
    man: () => import('./brands/Man'),
    scania: () => import('./brands/Scania'),
    peugeot: () => import('./brands/Peugeot'),
    renault: () => import('./brands/Renault'),
    gaz: () => import('./brands/Gaz'),
};

const iconCache = new Map();

// After a deploy old browser tabs hold hashed chunk URLs that 404. Without
// a retry the React tree throws and 60%+ of sessions hit a broken UI
// (Clarity flagged `loading chunk src_components_common_icon_painting_js
// failed`). Retry transient failures, then hard-reload once so the page
// fetches the new HTML referencing the new chunk hashes.
const loadIconWithRetry = (importFn, retries = 2, delay = 400) =>
    new Promise((resolve) => {
        const attempt = (remaining) => {
            importFn()
                .then((module) => {
                    resolve({
                        default:
                            module[Object.keys(module)[0]] || module.default,
                    });
                })
                .catch(() => {
                    if (remaining > 0) {
                        setTimeout(() => attempt(remaining - 1), delay);
                        return;
                    }
                    if (
                        typeof window !== 'undefined' &&
                        !window.__chunkReloadAttempted
                    ) {
                        // Hard reload once to fetch fresh chunk hashes when
                        // a deploy invalidated the cached entry. Don't
                        // resolve/reject; the reload aborts execution.
                        window.__chunkReloadAttempted = true;
                        window.location.reload();
                        return;
                    }
                    // Persistent failure (offline, blocked CDN, etc): render
                    // an empty placeholder rather than crashing Suspense and
                    // surfacing as a `loading chunk failed` JS error in
                    // Clarity. The icon slot stays empty but the page works.
                    resolve({ default: () => null });
                });
        };
        attempt(retries);
    });

const getLazyIcon = (name) => {
    if (!iconCache.has(name)) {
        const importFn = iconImports[name];
        if (!importFn) return null;

        iconCache.set(name, lazy(() => loadIconWithRetry(importFn)));
    }
    return iconCache.get(name);
};

export const iconNames = {
    instagram: 'instagram',
    tiktok: 'tiktok',
    plusIcon: 'plusIcon',
    cameraIcon: 'cameraIcon',
    disabledIcon: 'disabledIcon',
    copy: 'copy',
    audi: 'audi',
    carGradient: 'carGradient',
    bikeGradient: 'bikeGradient',
    close: 'close',
    youtube: 'youtube',
    navi: 'navi',
    premium: 'premium',
    list: 'list',
    good: 'good',
    lowPrice: 'lowPrice',
    highPrice: 'highPrice',
    search: 'search',
    clear: 'clear',
    edit: 'edit',
    mastercard: 'mastercard',
    visa: 'visa',
    rus: 'rus',
    ua: 'ua',
    geo: 'geo',
    eng: 'eng',
    taxi: 'taxi',
    clock: 'clock',
    jeep: 'jeep',
    carwashHood: 'carwashHood',
    bus: 'bus',
    audio: 'audio',
    chipTuning: 'chipTuning',
    shop: 'shop',
    dia: 'dia',
    fastSell: 'fastSell',
    lock: 'lock',
    autoschool: 'autoschool',
    piston: 'piston',
    carLoading: 'carLoading',
    key: 'key',
    carCrash: 'carCrash',
    account: 'account',
    abs: 'abs',
    addButton: 'addButton',
    airbag: 'airbag',
    auction: 'auction',
    autoservice: 'autoservice',
    suspension: 'suspension',
    accBattery: 'accBattery',
    bargain: 'bargain',
    bike: 'bike',
    car: 'car',
    carDoor: 'carDoor',
    carBoxGarage: 'carBoxGarage',
    carwash: 'carwash',
    check: 'check',
    motorsport: 'motorsport',
    phone: 'phone',
    mail: 'mail',
    place: 'place',
    link: 'link',
    dealer: 'dealer',
    company: 'company',
    commercial: 'commercial',
    expert: 'expert',
    placement: 'placement',
    service: 'service',
    danger: 'danger',
    parts: 'parts',
    verificate: 'verificate',
    photoDelete: 'photoDelete',
    starEmpty: 'starEmpty',
    starFull: 'starFull',
    info: 'info',
    gear: 'gear',
    garage: 'garage',
    gearbox: 'gearbox',
    fuel: 'fuel',
    fuelElectro: 'fuelElectro',
    fuelDiesel: 'fuelDiesel',
    speedometr: 'speedometr',
    documentCheck: 'documentCheck',
    documentNoCheck: 'documentNoCheck',
    driveunit: 'driveunit',
    engine: 'engine',
    transmission: 'transmission',
    user: 'user',
    pro: 'pro',
    exchange: 'exchange',
    defects: 'defects',
    disassembly: 'disassembly',
    driveWheel: 'driveWheel',
    photo: 'photo',
    repair: 'repair',
    restZone: 'restZone',
    seats: 'seats',
    seatsHeat: 'seatsHeat',
    seatsInvalid: 'seatsInvalid',
    sorting: 'sorting',
    tyreservice: 'tyreservice',
    video: 'video',
    wheels: 'wheels',
    wifi: 'wifi',
    vin: 'vin',
    date: 'date',
    owners: 'owners',
    climate: 'climate',
    color: 'color',
    cruise: 'cruise',
    online: 'online',
    plate: 'plate',
    credit: 'credit',
    carMechanic: 'carMechanic',
    gas: 'gas',
    oil: 'oil',
    insurance: 'insurance',
    fan: 'fan',
    towtruck: 'towtruck',
    painting: 'painting',
    exit: 'exit',
    rightCircle: 'rightCircle',
    minus: 'minus',
    location: 'location',
    cafe: 'cafe',
    compressor: 'compressor',
    water: 'water',
    electric: 'electric',
    electricService: 'electricService',
    pneumatic: 'pneumatic',
    light: 'light',
    tools: 'tools',
    discount: 'discount',
    hotDrinks: 'hotDrinks',
    microbus: 'microbus',
    trailer: 'trailer',
    tram: 'tram',
    loader: 'loader',
    top: 'top',
    carwashManual: 'carwashManual',
    carwashRobot: 'carwashRobot',
    checkboxEmpty: 'checkboxEmpty',
    checkboxFilled: 'checkboxFilled',
    police: 'police',
    money: 'money',
    sortingNumber: 'sortingNumber',
    checkmark: 'checkmark',
    eyeHide: 'eyeHide',
    eyeShow: 'eyeShow',
    statistic: 'statistic',
    childSeat: 'childSeat',
    bmw: 'bmw',
    ford: 'ford',
    honda: 'honda',
    hyundai: 'hyundai',
    kia: 'kia',
    lexus: 'lexus',
    mazda: 'mazda',
    mercedesBenz: 'mercedesBenz',
    nissan: 'nissan',
    toyota: 'toyota',
    volkswagen: 'volkswagen',
    aprilia: 'aprilia',
    ducati: 'ducati',
    harleyDavidson: 'harleyDavidson',
    indian: 'indian',
    kawasaki: 'kawasaki',
    ktm: 'ktm',
    royalEnfield: 'royalEnfield',
    suzuki: 'suzuki',
    triumph: 'triumph',
    yamaha: 'yamaha',
    daf: 'daf',
    isuzu: 'isuzu',
    iveco: 'iveco',
    man: 'man',
    scania: 'scania',
    peugeot: 'peugeot',
    renault: 'renault',
    gaz: 'gaz',
    stop: 'stop',
    news: 'news',
    bump: 'bump',
    highlight: 'highlight',
    whatsapp: 'whatsapp',
    viber: 'viber',
    telegram: 'telegram',
    share: 'share',
    facebook: 'facebook',
    copyLink: 'copyLink',
    reset: 'reset',
};

const LazyIconComponent = memo(({ name, fill, size, text }) => {
    const IconComponent = getLazyIcon(name);

    if (!IconComponent) {
        return null;
    }

    return (
        <Suspense fallback={<div style={{ width: size, height: size }} />}>
            <IconComponent fill={fill} width={size} height={size} text={text} />
        </Suspense>
    );
});

LazyIconComponent.displayName = 'LazyIconComponent';

const Icon = ({ onClick, name, fill, size = 40, text, className, label }) => {
    const icon = (
        <LazyIconComponent name={name} fill={fill} size={size} text={text} />
    );

    if (!onClick) {
        return <div className={`icon__block ${className || ''}`}>{icon}</div>;
    }

    return (
        <div
            role="button"
            tabIndex={0}
            aria-label={label}
            className={`icon__block ${className || ''}`}
            onClick={onClick}
            onKeyDown={onButtonKey(onClick)}
        >
            {icon}
        </div>
    );
};

export default memo(Icon);
